import { render, staticRenderFns } from "./WidgetPos_21.vue?vue&type=template&id=c76a118a"
import script from "./WidgetPos_21.vue?vue&type=script&lang=js"
export * from "./WidgetPos_21.vue?vue&type=script&lang=js"
import style0 from "./WidgetPos_21.vue?vue&type=style&index=0&id=c76a118a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports